<template>
  <a v-if="entry.join_url" :href="join_url()" :class="'btn-default btn-default__' + buttonColour()" v-tooltip="tooltipText()" @click.prevent="join()">{{ buttonText() }}</a>
</template>


<script>
import OpenPopup from '../utils/OpenPopup';

export default {
  name: 'WhatsHappeningEntryJoinButton',
  props: ['entry','tellAttendeeToGoToTheMeetingAt','closeToEntry'],
  created() {
    this.closePopupIntervals = []
  },
  methods: {
    buttonText() {
      return `JOIN ${this.entry.type.toUpperCase()}`
    },
    buttonColour() {
      if (this.closeToEntry) {
        return 'green'
      } else {
        return 'gray'
      }
    },
    join_url() {
      if (this.closeToEntry) {
        return this.entry.join_url;
      } else {
        null
      }
    },
    tooltipText() {
      if (this.closeToEntry) { return null }
      let time = this.tellAttendeeToGoToTheMeetingAt.toLocaleString("en-GB", {timeZone: "Europe/London"}).slice(12,17)
      return `You will be able to join at ${time}`
    },
    join() {
      if (this.entry.type == 'meeting') {
        this.entry.clicked_to_join = true
        this.$http.secured.post(`/attendee_api/v1/meetings/${this.entry.meeting_id}/clicked_to_join`)
      }
      this.openPopup()
    },
    openPopup() {
      let width = null
      if (this.join_url().match(/zoom/)) {
        width = '60%';
      } else {
        width = '75%';
      }
      const popup = OpenPopup(this.join_url(), this.entry.title, width, '16:9')
      if (this.entry.type == 'meeting' && this.entry.ends_at) {
        this.closePopupAt(popup, new Date(this.entry.ends_at))
      }
    },
    closePopupAt(popup, closeAt) {
      const interval = setInterval(() => {
        if (popup && closeAt < this.$store.state.currentTime && !popup.closed) {
          popup.close()
        }

        if (!popup || popup.closed) {
          clearInterval(interval)
        }
      }, 2000)
    },
    beforeDestroy () {
      for (const interval of this.closePopupIntervals) {
        clearInterval(interval)
      }
    }
  }
}
</script>
